import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { DemoProvider } from './app/context/DemoContext.jsx'
import Home from './app/page.jsx'
import About from './app/about/page.jsx'
import Service from './app/service/page.jsx'
import Contact from './app/contact/page.jsx'
import Team from './app/team/page.jsx'
import Testimonial from './app/testimonial/page.jsx'
import ChooseUs from './app/choose-us/page.jsx'
import AISolutions from './app/ai-solutions/page.jsx'
import BlockchainConsulting from './app/blockchain-consulting/page.jsx'
import CentralizedExchangeSolutions from './app/centralized-exchange-solutions/page.jsx'
import DecentralizedExchangeSolutions from './app/decentralized-exchange-solutions/page.jsx'
import Web3DAppSolutions from './app/Web3-dApp-solutions/page.jsx'
import VolumeBoosting from './app/volume-boosting/page.jsx'
import InteractiveDigitalArt from './app/interactive-digitalArt/page.jsx'

function App() {
  return (
    <DemoProvider>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/service" element={<Service />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/team" element={<Team />} />
        <Route path="/testimonial" element={<Testimonial />} />
        <Route path="/choose-us" element={<ChooseUs />} />
        <Route path="/ai-solutions" element={<AISolutions />} />
        <Route path="/blockchain-consulting" element={<BlockchainConsulting />} />
        <Route path="/centralized-exchange-solutions" element={<CentralizedExchangeSolutions />} />
        <Route path="/decentralized-exchange-solutions" element={<DecentralizedExchangeSolutions />} />
        <Route path="/web3-dapp-solutions" element={<Web3DAppSolutions />} />
        <Route path="/volume-boosting" element={<VolumeBoosting />} />
        <Route path="/interactive-digitalArt" element={<InteractiveDigitalArt />} />
      </Routes>
    </DemoProvider>
  )
}

export default App
